import { Link } from "react-router-dom";
import ArticleCard, { type ArticleItem } from "@/components/base/ArticleCard";

interface Props {
  items: ArticleItem[];
}

export default function LatestGrid({ items }: Props) {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <span className="text-xs font-medium text-primary-600 tracking-[0.2em]">LATEST</span>
          <h2 className="mt-2 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            最新爆料
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
            过去 48 小时内持续发酵的话题，按发布时间从新到旧排列。
          </p>
        </div>
        <Link
          to="/daily"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-foreground-300 text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部爆料
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {items.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>
    </section>
  );
}